import React, { useMemo } from 'react'
import Dropdown from 'core/elements/dropdown'
import withProgress from 'core/components/progress/withProgress'
import useListAction from 'core/hooks/useListAction'
import { listImages } from './actions'
import { useSelector } from 'react-redux'
import { imagesSelector } from './selectors'
import GlobalDropdownWithSearch from 'core/elements/dropdown/GlobalDropdownWithSearch'

const AsyncDropdown = withProgress(Dropdown, { inline: true })

interface ImagePicklistProps {
  disabled?: boolean
  name?: string
  label?: string
  includeNoneOption?: boolean
  includeAllOption?: boolean
  compact?: boolean
  onChange: (value: string) => void
  value: string
  width?: number
  align?: 'left' | 'right'
  [key: string]: any
}

export default function ImagePicklist({
  disabled = false,
  name = 'image',
  label = 'Image',
  includeNoneOption = false,
  includeAllOption = false,
  compact = true,
  onChange,
  value,
  width = 180,
  align = 'right',
  ...rest
}: ImagePicklistProps) {
  const { loading } = useListAction(listImages)
  const images = useSelector(imagesSelector)

  const items = useMemo(() => {
    const imageOptions = images.map((image) => ({
      label: image.name,
      value: image.id,
    }))

    const result = []
    if (includeAllOption) {
      result.push({ label: 'All', value: 'all' })
    }
    if (includeNoneOption) {
      result.push({ label: '-- None --', value: '' })
    }
    return [...result, ...imageOptions]
  }, [images, includeNoneOption, includeAllOption])

  return compact ? (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      loading={loading}
      items={items}
    />
  ) : (
    <GlobalDropdownWithSearch
      label={label}
      items={items}
      loading={loading}
      onChange={(item) => onChange(item.value)}
      value={value}
      showLabelOnTop
      align={align}
      disabled={disabled}
      width={width}
    />
  )
}
